import s from './SplitLineDesktop.module.css';
export default function SplitLineDesktop() {
  return <div className={s.line}></div>;
}
